export const buttonTypeNames = {
    numberBox: 'NumberBox',
    selectBox: 'SelectBox',
    textBox: 'TextBox'
}

export const formGroupNames = {
    address: 'address',
    administrative: 'administrative',
    costs: 'costs'
};